import type { AdminCrewReportStatisticsPdfExportViewProps } from "../../models/admin-crew-report.models";
import { ADMIN_CREW_REPORT_STATISTICS_VIEW_LABELS } from "../../utils/admin-crew-report.constants";
import AdminCrewReportStatisticsCards from "./AdminCrewReportStatisticsCards";
import { createPortal } from "react-dom";

const AdminCrewReportStatisticsPdfExportView = ({ statistics, view }: AdminCrewReportStatisticsPdfExportViewProps) => {
  const sectionTitle = ADMIN_CREW_REPORT_STATISTICS_VIEW_LABELS[view].sectionTitle;

  return createPortal(
    <div
      data-test="admin-crew-report-statistics-pdf-export-view"
      data-testid="admin-crew-report-statistics-pdf-export-view"
      data-statistics-view={view}
      className="admin-crew-report-statistics-print-root"
    >
      <div className="admin-crew-report-statistics-print-export">
        <header className="admin-crew-report-statistics-print-header">
          <h1>{sectionTitle}</h1>
        </header>
        <div className="admin-crew-report-statistics-print-grid">
          <AdminCrewReportStatisticsCards statistics={statistics} view={view} />
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default AdminCrewReportStatisticsPdfExportView;
